<template>
  <div v-if="shouldShow" class="binds-image-viewer-container" :class="[position, imageSize]">
    <div class="binds-image-container binds-animated-faster zoomIn">
      <zoomable-image
        :image="image"
        :container-class="containerClass"
        :has-background="false"
        :show-label="false"
        :question-type="questionType"
        :show-image-on-title="true"
      />
    </div>
  </div>
</template>

<script>
import ZoomableImage from './ZoomableImage.vue'

export default {
  name: 'ImageViewer',
  components: {
    ZoomableImage
  },
  props: {
    image: {
      type: [String, Object],
      required: true
    },
    position: {
      type: String,
      default: 'middle',
      validator: value => ['middle', 'top-left', 'top-right', 'left'].includes(value)
    },
    questionType: {
      type: String,
      default: ''
    },
    imageSize: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    }
  },
  computed: {
    shouldShow () {
      return this.image && (typeof this.image === 'string' || (this.image.label && this.image.value))
    },
    containerClass () {
      return this.position === 'middle' ? 'middle-container' : ''
    }
  }
}
</script>

<style lang="scss">
.binds-image-viewer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 15px;
  max-width: 100%;
  .binds-image-container {
    width: 100%;
    height: 100%;
  }

  &.small {
    .binds-image-container {
      width: 150px;
      height: 150px;
    }
  }

  &.medium {
    .binds-image-container {
      width: 160px;
      height: 160px;
    }
  }

  &.large {
    .binds-image-container {
      width: 300px;
      height: 300px;
    }
  }

  &.middle {
    margin: 0 auto;
    padding: 10px;
  }

  &.top-left, &.top-right, &.left {
    position: relative;
    padding: 10px;
  }
}

@media screen and (max-width: 430px) {
  .binds-image-viewer-container {
    padding: 15px 10px;

    &.small {
      .binds-image-container {
        width: 120px;
        height: 120px;
      }
    }

    &.medium {
      .binds-image-container {
        width: 160px;
        height: 160px;
      }
    }

    &.large {
      .binds-image-container {
        width: 240px;
        height: 240px;
      }
    }
  }
}

@media screen and (max-width: 360px) {
  .binds-image-viewer-container {
    padding: 10px;

    &.small {
      .binds-image-container {
        width: 100px;
        height: 100px;
      }
    }

    &.medium {
      .binds-image-container {
        width: 140px;
        height: 140px;
      }
    }

    &.large {
      .binds-image-container {
        width: 200px;
        height: 200px;
      }
    }
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
